import React from "react";
import "./Testimonials.css";

const Testimonials = () => {
  return (
    <div className="testimonials">
      <div className="left-t"></div>
      <div className="right-t"></div>
      <span>Testimonials</span>
      <span className="stroke-text">What they</span>
      <span>say about us</span>
      <span style="opacity: 1; transform: none;">
        I made the right choice by choosing the Fitclub and by choosing the
        right plan and program I already achieved my ideal body!
      </span>
    </div>
  );
};

export default Testimonials;
